import { render, staticRenderFns } from "./personal-editions.vue?vue&type=template&id=0d76e254&scoped=true&"
import script from "./personal-editions.vue?vue&type=script&lang=ts&"
export * from "./personal-editions.vue?vue&type=script&lang=ts&"
import style0 from "./personal-editions.vue?vue&type=style&index=0&id=0d76e254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d76e254",
  null
  
)

export default component.exports